<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="24" :md="24">
        <el-input v-model="filtro.nome" placeholder="Pesquisar alimento" @keyup.native.enter="load"></el-input>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="8" :md="8">
        <el-select v-model="filtro.categoria_id" placeholder="Categoria" filterable clearable @change="load" style="width: 100%;">
          <el-option v-for="c in categorias" :key="c.id" :label="c.nome" :value="c.id"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <el-select v-model="filtro.perecivel" placeholder="Perecível" clearable>
          <el-option label="SIM" :value="true"></el-option>
          <el-option label="NÃO" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <router-link to="/admin/merenda/alimento/cadastro" class="btn-new-register">
          <el-button type="primary">NOVO ALIMENTO</el-button>
        </router-link>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Nome</th>
            <th class="hidden-mobile">Categoria</th>
            <th class="hidden-mobile" style="width: 90px;">Unid.</th>
            <th class="hidden-mobile u-text-center" style="width: 90px;">Perecível</th>
            <th class="hidden-mobile u-text-center" style="width: 90px;">Ativo</th>
            <th style="width: 180px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome }}</td>
            <td class="hidden-mobile">{{ (item.categoria && item.categoria.nome) || '-' }}</td>
            <td class="hidden-mobile">{{ item.unidade_medida || '-' }}</td>
            <td class="hidden-mobile u-text-center">{{ item.perecivel ? 'SIM' : 'NÃO' }}</td>
            <td class="hidden-mobile u-text-center">{{ item.ativo ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao">
              <router-link :to="'/admin/merenda/alimento/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="toggleAtivo(item)" :title="item.ativo ? 'Desativar' : 'Ativar'" type="warning" icon="el-icon-refresh" size="mini" plain></el-button>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>

      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">
            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: { nome: '', categoria_id: '', perecivel: '' },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: [],
    categorias: []
  }),
  mounted () {
    this.loadCategorias()
    this.load()
  },
  methods: {
    loadCategorias () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/categoria/getAll`, { ativo: true }, this.$store.getters.getHeaderAuth)
        .then(response => { this.categorias = response.data || [] })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    load () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    toggleAtivo (item) {
      window.eventBus.$emit('loading', true)
      const payload = Object.assign({}, item, { ativo: !item.ativo })
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/update/` + item.id, payload, this.$store.getters.getHeaderAuth)
        .then(() => {
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.load()
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este alimento?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.load()
    }
  }
}
</script>

